import { render, staticRenderFns } from "./freeSpinLogTab.vue?vue&type=template&id=7fca398a&lang=pug"
import script from "./freeSpinLogTab.vue?vue&type=script&lang=js"
export * from "./freeSpinLogTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports